// extracted by mini-css-extract-plugin
export var csatScore = "_mq-5";
export var header = "_mq-1";
export var panelWrapper = "_mq-2";
export var postPreview = "_mq-3";
export var rightContent = "_mq-0";
export var wrappingText = "_mq-4";